import React from 'react'
import { ArrowUpward, ArrowDownward } from '@material-ui/icons'

const DashboardTopInfo = ({ deltas, isLoadingDeltas }) => {
  const calcularValor = (actual, anterior) => {
    const diferencia = actual - anterior
    if (diferencia > 0) {
      return (
        <>
          {actual} + {diferencia} <ArrowUpward style={{ color: 'green' }} />
        </>
      )
    }
    if (diferencia < 0) {
      return (
        <>
          {actual} {diferencia} <ArrowDownward style={{ color: 'red' }} />
        </>
      )
    }
    return actual
  }

  const actual = deltas[0]
  const anterior = deltas[1]

  const metricas = [
    { key: 'cartera', label: 'Cartera', value: actual?.cartera, anteriorValue: anterior?.cartera },
    { key: 'disponibilidad', label: 'Disponibilidad', value: actual?.disponibilidad, anteriorValue: anterior?.disponibilidad },
    { key: 'operacion_cedi', label: 'Proceso CEDI', value: actual?.operacion_cedi, anteriorValue: anterior?.operacion_cedi },
    { key: 'salida_mercancia', label: 'Sal Mercancia', value: actual?.salida_mercancia, anteriorValue: anterior?.salida_mercancia },
    { key: 'salida_mercancia_alma_viva', label: 'Sal Mercancia Alma Viva', value: actual?.salida_mercancia_alma_viva, anteriorValue: anterior?.salida_mercancia_alma_viva },
    { key: 'transporte', label: 'Transporte', value: actual?.transporte, anteriorValue: anterior?.transporte },
    { key: 'entrega_cliente', label: 'Entrega Cliente', value: actual?.entrega_cliente, anteriorValue: anterior?.entrega_cliente },
  ]

  return (
    <div className="top-info">
      {metricas.map(({ key, label, value, anteriorValue }) => (
        <div key={key} className={`info-item ${isLoadingDeltas ? 'my-loading' : ''}`}>
          <p>{label}</p>
          <p>
            {deltas[1] ? calcularValor(value, anteriorValue) : 0}
          </p>
        </div>
      ))}
    </div>
  )
}

export default DashboardTopInfo 